<h1 mat-dialog-title>Search outlet</h1>

<div mat-dialog-content>

  <mat-form-field class="example-full-width">
    <mat-label>Filter: Name</mat-label>
    <input matInput placeholder="Name">
  </mat-form-field>

  @if (isLoading) {
    <mat-progress-spinner mode="indeterminate" color="primary" [diameter]="40"></mat-progress-spinner>
  }

  <table [class.grid-loading]="isLoading" mat-table [dataSource]="outlets$ | async" style="width: 100%;">
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef> State </th>
      <td mat-cell *matCellDef="let element"> {{ element.state }} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Name </th>
      <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
    </ng-container>

    <ng-container matColumnDef="formattedAddress">
      <th mat-header-cell *matHeaderCellDef> Address </th>
      <td mat-cell *matCellDef="let element"> {{ element.formattedAddress }} </td>
    </ng-container>

    <ng-container matColumnDef="vendorName">
      <th mat-header-cell *matHeaderCellDef> Vendor name </th>
      <td mat-cell *matCellDef="let element"> {{ element.vendorName }} </td>
    </ng-container>

    <ng-container matColumnDef="externalId">
      <th mat-header-cell *matHeaderCellDef> External Id </th>
      <td mat-cell *matCellDef="let element"> {{ element.externalId }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['state', 'name', 'formattedAddress', 'vendorName', 'externalId']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['state', 'name', 'formattedAddress', 'vendorName', 'externalId'];" (click)="selectOutlet(row)"></tr>
  </table>

</div>

<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="">Cancel</button>
</div>